/* @generated from adl module totalinteraction.futurefit.db.scodlemigration */

import * as ADL from './../../../runtime/adl';
import * as common from './../../../common';
import * as common_db from './../../../common/db';
import * as totalinteraction_futurefit_db from './../db';

/**
 * Control data for specific clients
 */
export interface ScodleControl {
  /**
   * Migration client
   */
  appClientId: common_db.DbKey<totalinteraction_futurefit_db.AppClient>;
  /**
   * "Username" (= Scodle domain) for API
   */
  username: string;
  /**
   * Password
   */
  password: string;
  /**
   * API Endpoint
   */
  apiEndpoint: string;
}

export function makeScodleControl(
  input: {
    appClientId: common_db.DbKey<totalinteraction_futurefit_db.AppClient>,
    username: string,
    password: string,
    apiEndpoint: string,
  }
): ScodleControl {
  return {
    appClientId: input.appClientId,
    username: input.username,
    password: input.password,
    apiEndpoint: input.apiEndpoint,
  };
}

const ScodleControl_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.scodlemigration","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appClientId","default":{"kind":"nothing"},"name":"appClientId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClient"}},"parameters":[]}]}},{"annotations":[],"serializedName":"username","default":{"kind":"nothing"},"name":"username","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"password","default":{"kind":"nothing"},"name":"password","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"apiEndpoint","default":{"kind":"nothing"},"name":"apiEndpoint","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"ScodleControl","version":{"kind":"nothing"}}};

export const snScodleControl: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.scodlemigration", name:"ScodleControl"};

export function texprScodleControl(): ADL.ATypeExpr<ScodleControl> {
  return {value : {typeRef : {kind: "reference", value : snScodleControl}, parameters : []}};
}

export interface ImportEvent {
  sourceId: common_db.DbKey<ScodleControl>;
  start: common.Instant;
  finish: (common.Instant|null);
  status: string;
}

export function makeImportEvent(
  input: {
    sourceId: common_db.DbKey<ScodleControl>,
    start: common.Instant,
    finish: (common.Instant|null),
    status: string,
  }
): ImportEvent {
  return {
    sourceId: input.sourceId,
    start: input.start,
    finish: input.finish,
    status: input.status,
  };
}

const ImportEvent_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.scodlemigration","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"sourceId","default":{"kind":"nothing"},"name":"sourceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ScodleControl"}},"parameters":[]}]}},{"annotations":[],"serializedName":"start","default":{"kind":"nothing"},"name":"start","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"finish","default":{"kind":"nothing"},"name":"finish","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"ImportEvent","version":{"kind":"nothing"}}};

export const snImportEvent: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.scodlemigration", name:"ImportEvent"};

export function texprImportEvent(): ADL.ATypeExpr<ImportEvent> {
  return {value : {typeRef : {kind: "reference", value : snImportEvent}, parameters : []}};
}

/**
 * A "course" in SCORM. Maps to a Quiz
 */
export interface ScormCourse {
  importId: common_db.DbKey<ImportEvent>;
  courseid: string;
  name: string;
  shortname: string;
  /**
   * Usually contains YAML-formatted settings delimited by "---"
   */
  description: string;
  startdate: common.Instant;
  enrolperiod: string;
}

export function makeScormCourse(
  input: {
    importId: common_db.DbKey<ImportEvent>,
    courseid: string,
    name: string,
    shortname: string,
    description: string,
    startdate: common.Instant,
    enrolperiod: string,
  }
): ScormCourse {
  return {
    importId: input.importId,
    courseid: input.courseid,
    name: input.name,
    shortname: input.shortname,
    description: input.description,
    startdate: input.startdate,
    enrolperiod: input.enrolperiod,
  };
}

const ScormCourse_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.scodlemigration","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["courseid"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"importId","default":{"kind":"nothing"},"name":"importId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ImportEvent"}},"parameters":[]}]}},{"annotations":[],"serializedName":"courseid","default":{"kind":"nothing"},"name":"courseid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"shortname","default":{"kind":"nothing"},"name":"shortname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"startdate","default":{"kind":"nothing"},"name":"startdate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"enrolperiod","default":{"kind":"nothing"},"name":"enrolperiod","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"ScormCourse","version":{"kind":"nothing"}}};

export const snScormCourse: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.scodlemigration", name:"ScormCourse"};

export function texprScormCourse(): ADL.ATypeExpr<ScormCourse> {
  return {value : {typeRef : {kind: "reference", value : snScormCourse}, parameters : []}};
}

/**
 * Intermediate table bwtween SCORM course and SS Quiz
 */
export interface ScormCoursePreload {
  /**
   * Copied from ScormCourse
   */
  id: common_db.DbKey<ScormCourse>;
  importId: common_db.DbKey<ImportEvent>;
  courseid: (string|null);
  name: (string|null);
  shortname: (string|null);
  startdate: (common.Instant|null);
  quizId: (common_db.DbKey<totalinteraction_futurefit_db.Quiz>|null);
  showRecommendations: boolean;
  showRoleAverage: boolean;
  seriesNameExpected: (string|null);
  seriesNameGroupAverage: (string|null);
  seriesNameRoleAverage: (string|null);
  seriesNameCurrentSkills: (string|null);
  seriesNameFilteredAverage: (string|null);
  showGroupAverage: boolean;
  workRoleId: (common_db.DbKey<totalinteraction_futurefit_db.WorkRole>|null);
}

export function makeScormCoursePreload(
  input: {
    id: common_db.DbKey<ScormCourse>,
    importId: common_db.DbKey<ImportEvent>,
    courseid: (string|null),
    name: (string|null),
    shortname: (string|null),
    startdate: (common.Instant|null),
    quizId: (common_db.DbKey<totalinteraction_futurefit_db.Quiz>|null),
    showRecommendations?: boolean,
    showRoleAverage?: boolean,
    seriesNameExpected?: (string|null),
    seriesNameGroupAverage?: (string|null),
    seriesNameRoleAverage?: (string|null),
    seriesNameCurrentSkills?: (string|null),
    seriesNameFilteredAverage?: (string|null),
    showGroupAverage?: boolean,
    workRoleId: (common_db.DbKey<totalinteraction_futurefit_db.WorkRole>|null),
  }
): ScormCoursePreload {
  return {
    id: input.id,
    importId: input.importId,
    courseid: input.courseid,
    name: input.name,
    shortname: input.shortname,
    startdate: input.startdate,
    quizId: input.quizId,
    showRecommendations: input.showRecommendations === undefined ? true : input.showRecommendations,
    showRoleAverage: input.showRoleAverage === undefined ? true : input.showRoleAverage,
    seriesNameExpected: input.seriesNameExpected === undefined ? "Desired" : input.seriesNameExpected,
    seriesNameGroupAverage: input.seriesNameGroupAverage === undefined ? "Group Average" : input.seriesNameGroupAverage,
    seriesNameRoleAverage: input.seriesNameRoleAverage === undefined ? "Industry Average" : input.seriesNameRoleAverage,
    seriesNameCurrentSkills: input.seriesNameCurrentSkills === undefined ? "Current Skills" : input.seriesNameCurrentSkills,
    seriesNameFilteredAverage: input.seriesNameFilteredAverage === undefined ? "Current Skills" : input.seriesNameFilteredAverage,
    showGroupAverage: input.showGroupAverage === undefined ? true : input.showGroupAverage,
    workRoleId: input.workRoleId,
  };
}

const ScormCoursePreload_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.scodlemigration","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ScormCourse"}},"parameters":[]}]}},{"annotations":[],"serializedName":"importId","default":{"kind":"nothing"},"name":"importId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ImportEvent"}},"parameters":[]}]}},{"annotations":[],"serializedName":"courseid","default":{"kind":"nothing"},"name":"courseid","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"shortname","default":{"kind":"nothing"},"name":"shortname","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"startdate","default":{"kind":"nothing"},"name":"startdate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"quizId","default":{"kind":"nothing"},"name":"quizId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Quiz"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"showRecommendations","default":{"kind":"just","value":true},"name":"showRecommendations","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"showRoleAverage","default":{"kind":"just","value":true},"name":"showRoleAverage","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"seriesNameExpected","default":{"kind":"just","value":"Desired"},"name":"seriesNameExpected","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"seriesNameGroupAverage","default":{"kind":"just","value":"Group Average"},"name":"seriesNameGroupAverage","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"seriesNameRoleAverage","default":{"kind":"just","value":"Industry Average"},"name":"seriesNameRoleAverage","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"seriesNameCurrentSkills","default":{"kind":"just","value":"Current Skills"},"name":"seriesNameCurrentSkills","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"seriesNameFilteredAverage","default":{"kind":"just","value":"Current Skills"},"name":"seriesNameFilteredAverage","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"showGroupAverage","default":{"kind":"just","value":true},"name":"showGroupAverage","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"workRoleId","default":{"kind":"nothing"},"name":"workRoleId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"WorkRole"}},"parameters":[]}]}]}}]}},"name":"ScormCoursePreload","version":{"kind":"nothing"}}};

export const snScormCoursePreload: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.scodlemigration", name:"ScormCoursePreload"};

export function texprScormCoursePreload(): ADL.ATypeExpr<ScormCoursePreload> {
  return {value : {typeRef : {kind: "reference", value : snScormCoursePreload}, parameters : []}};
}

/**
 * A user in SCORM. Maps to AppUser via appClientId/email
 */
export interface ScormUser {
  importId: common_db.DbKey<ImportEvent>;
  userid: string;
  firstname: string;
  lastname: string;
  email: string;
  profileurl: string;
  loginurl: string;
  /**
   * Optional profile fields - used to populate UserGroups
   */
  manager: (string|null);
  role: (string|null);
  location: (string|null);
  position: (string|null);
  team: (string|null);
}

export function makeScormUser(
  input: {
    importId: common_db.DbKey<ImportEvent>,
    userid: string,
    firstname: string,
    lastname: string,
    email: string,
    profileurl: string,
    loginurl: string,
    manager: (string|null),
    role: (string|null),
    location: (string|null),
    position: (string|null),
    team: (string|null),
  }
): ScormUser {
  return {
    importId: input.importId,
    userid: input.userid,
    firstname: input.firstname,
    lastname: input.lastname,
    email: input.email,
    profileurl: input.profileurl,
    loginurl: input.loginurl,
    manager: input.manager,
    role: input.role,
    location: input.location,
    position: input.position,
    team: input.team,
  };
}

const ScormUser_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.scodlemigration","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["userid"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"importId","default":{"kind":"nothing"},"name":"importId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ImportEvent"}},"parameters":[]}]}},{"annotations":[],"serializedName":"userid","default":{"kind":"nothing"},"name":"userid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"firstname","default":{"kind":"nothing"},"name":"firstname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"lastname","default":{"kind":"nothing"},"name":"lastname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"profileurl","default":{"kind":"nothing"},"name":"profileurl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"loginurl","default":{"kind":"nothing"},"name":"loginurl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"manager","default":{"kind":"nothing"},"name":"manager","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"role","default":{"kind":"nothing"},"name":"role","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"location","default":{"kind":"nothing"},"name":"location","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"position","default":{"kind":"nothing"},"name":"position","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"team","default":{"kind":"nothing"},"name":"team","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"ScormUser","version":{"kind":"nothing"}}};

export const snScormUser: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.scodlemigration", name:"ScormUser"};

export function texprScormUser(): ADL.ATypeExpr<ScormUser> {
  return {value : {typeRef : {kind: "reference", value : snScormUser}, parameters : []}};
}

export interface ScormUserPreload {
  /**
   * Copied from ScormUser
   */
  id: common_db.DbKey<ScormUser>;
  /**
   * The SCORM user ID - the ID field => AppUserId
   */
  scormUserId: string;
  /**
   * firstname + lastname
   */
  fullname: string;
  email: string;
  /**
   * Search for manager field in ScormUser and set
   */
  isManager: boolean;
  appClientId: common_db.DbKey<totalinteraction_futurefit_db.AppClient>;
  originalImportId: common_db.DbKey<ImportEvent>;
  /**
   * Use for subsequent imports
   */
  updateImportId: (common_db.DbKey<ImportEvent>|null);
  /**
   * Set manually to exclude Scodle or TIA users
   */
  nonClientUser: boolean;
  /**
   * Search manager field in ScormUser and use to query ID ( => AppUserId)
   */
  managerId: string;
  /**
   * Internal use to manage imports
   */
  note: (string|null);
  /**
   * Internal use to manage imports - eg. use, ignore, or ref to other user ID (where same user has different Scodle userIDs)
   */
  action: (string|null);
}

export function makeScormUserPreload(
  input: {
    id: common_db.DbKey<ScormUser>,
    scormUserId: string,
    fullname: string,
    email: string,
    isManager?: boolean,
    appClientId: common_db.DbKey<totalinteraction_futurefit_db.AppClient>,
    originalImportId: common_db.DbKey<ImportEvent>,
    updateImportId: (common_db.DbKey<ImportEvent>|null),
    nonClientUser?: boolean,
    managerId: string,
    note: (string|null),
    action: (string|null),
  }
): ScormUserPreload {
  return {
    id: input.id,
    scormUserId: input.scormUserId,
    fullname: input.fullname,
    email: input.email,
    isManager: input.isManager === undefined ? false : input.isManager,
    appClientId: input.appClientId,
    originalImportId: input.originalImportId,
    updateImportId: input.updateImportId,
    nonClientUser: input.nonClientUser === undefined ? false : input.nonClientUser,
    managerId: input.managerId,
    note: input.note,
    action: input.action,
  };
}

const ScormUserPreload_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.scodlemigration","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"uniquenessConstraints":[["id, app_client_id"],["scorm_user_id"],["email"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ScormUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"scormUserId","default":{"kind":"nothing"},"name":"scormUserId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"isManager","default":{"kind":"just","value":false},"name":"isManager","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"appClientId","default":{"kind":"nothing"},"name":"appClientId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"AppClient"}},"parameters":[]}]}},{"annotations":[],"serializedName":"originalImportId","default":{"kind":"nothing"},"name":"originalImportId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ImportEvent"}},"parameters":[]}]}},{"annotations":[],"serializedName":"updateImportId","default":{"kind":"nothing"},"name":"updateImportId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ImportEvent"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"nonClientUser","default":{"kind":"just","value":false},"name":"nonClientUser","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"managerId","default":{"kind":"nothing"},"name":"managerId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"note","default":{"kind":"nothing"},"name":"note","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"action","default":{"kind":"nothing"},"name":"action","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"ScormUserPreload","version":{"kind":"nothing"}}};

export const snScormUserPreload: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.scodlemigration", name:"ScormUserPreload"};

export function texprScormUserPreload(): ADL.ATypeExpr<ScormUserPreload> {
  return {value : {typeRef : {kind: "reference", value : snScormUserPreload}, parameters : []}};
}

/**
 * ----- [ TODO: Missing: Group and Manager info ] -----
 * An enrolment in SCORM. Maps to UserQuiz
 */
export interface ScormEnrolment {
  importId: common_db.DbKey<ImportEvent>;
  enrolmentid: string;
  userid: string;
  courseid: string;
}

export function makeScormEnrolment(
  input: {
    importId: common_db.DbKey<ImportEvent>,
    enrolmentid: string,
    userid: string,
    courseid: string,
  }
): ScormEnrolment {
  return {
    importId: input.importId,
    enrolmentid: input.enrolmentid,
    userid: input.userid,
    courseid: input.courseid,
  };
}

const ScormEnrolment_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.scodlemigration","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["import_id, enrolmentid"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"importId","default":{"kind":"nothing"},"name":"importId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ImportEvent"}},"parameters":[]}]}},{"annotations":[],"serializedName":"enrolmentid","default":{"kind":"nothing"},"name":"enrolmentid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"userid","default":{"kind":"nothing"},"name":"userid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"courseid","default":{"kind":"nothing"},"name":"courseid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"ScormEnrolment","version":{"kind":"nothing"}}};

export const snScormEnrolment: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.scodlemigration", name:"ScormEnrolment"};

export function texprScormEnrolment(): ADL.ATypeExpr<ScormEnrolment> {
  return {value : {typeRef : {kind: "reference", value : snScormEnrolment}, parameters : []}};
}

export type ScormScore = string;

const ScormScore_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.scodlemigration","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"ScormScore","version":{"kind":"nothing"}}};

export const snScormScore: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.scodlemigration", name:"ScormScore"};

export function texprScormScore(): ADL.ATypeExpr<ScormScore> {
  return {value : {typeRef : {kind: "reference", value : snScormScore}, parameters : []}};
}

export type ScormCompletionStatus = string;

const ScormCompletionStatus_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.scodlemigration","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"ScormCompletionStatus","version":{"kind":"nothing"}}};

export const snScormCompletionStatus: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.scodlemigration", name:"ScormCompletionStatus"};

export function texprScormCompletionStatus(): ADL.ATypeExpr<ScormCompletionStatus> {
  return {value : {typeRef : {kind: "reference", value : snScormCompletionStatus}, parameters : []}};
}

/**
 * Fetching a set of tracks (for all users etc) gets these. 
 * This is a summary of the course session (part of UserQuiz)
 * Sub-structures flattened out, and this also irons out
 * the SCO name and SCORM version issues
 */
export interface ScormTrackSummary {
  importId: common_db.DbKey<ImportEvent>;
  trackid: string;
  userid: string;
  courseid: string;
  openedat: common.Instant;
  /**
   * Logged here for reference
   */
  SCOName: string;
  /**
   * Logged here for reference
   */
  SCORMVersion: string;
  /**
   * Flattened out from  '[SCO name].cmi.core' object (SCORM 1.2) or '[SCO name].cmi' object (SCORM 2004)
   */
  completion_status: ScormCompletionStatus;
  total_time: (string|null);
  scoreRaw: (ScormScore|null);
  totaltime: (string|null);
  completedat: (common.Instant|null);
}

export function makeScormTrackSummary(
  input: {
    importId: common_db.DbKey<ImportEvent>,
    trackid: string,
    userid: string,
    courseid: string,
    openedat: common.Instant,
    SCOName: string,
    SCORMVersion: string,
    completion_status: ScormCompletionStatus,
    total_time: (string|null),
    scoreRaw: (ScormScore|null),
    totaltime: (string|null),
    completedat: (common.Instant|null),
  }
): ScormTrackSummary {
  return {
    importId: input.importId,
    trackid: input.trackid,
    userid: input.userid,
    courseid: input.courseid,
    openedat: input.openedat,
    SCOName: input.SCOName,
    SCORMVersion: input.SCORMVersion,
    completion_status: input.completion_status,
    total_time: input.total_time,
    scoreRaw: input.scoreRaw,
    totaltime: input.totaltime,
    completedat: input.completedat,
  };
}

const ScormTrackSummary_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.scodlemigration","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["import_id, trackid"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"importId","default":{"kind":"nothing"},"name":"importId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ImportEvent"}},"parameters":[]}]}},{"annotations":[],"serializedName":"trackid","default":{"kind":"nothing"},"name":"trackid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"userid","default":{"kind":"nothing"},"name":"userid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"courseid","default":{"kind":"nothing"},"name":"courseid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"openedat","default":{"kind":"nothing"},"name":"openedat","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"SCOName","default":{"kind":"nothing"},"name":"SCOName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"SCORMVersion","default":{"kind":"nothing"},"name":"SCORMVersion","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"completion_status","default":{"kind":"nothing"},"name":"completion_status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ScormCompletionStatus"}},"parameters":[]}},{"annotations":[],"serializedName":"total_time","default":{"kind":"nothing"},"name":"total_time","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"scoreRaw","default":{"kind":"nothing"},"name":"scoreRaw","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ScormScore"}},"parameters":[]}]}},{"annotations":[],"serializedName":"totaltime","default":{"kind":"nothing"},"name":"totaltime","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"completedat","default":{"kind":"nothing"},"name":"completedat","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}}]}},"name":"ScormTrackSummary","version":{"kind":"nothing"}}};

export const snScormTrackSummary: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.scodlemigration", name:"ScormTrackSummary"};

export function texprScormTrackSummary(): ADL.ATypeExpr<ScormTrackSummary> {
  return {value : {typeRef : {kind: "reference", value : snScormTrackSummary}, parameters : []}};
}

/**
 * Intermediate table between SCORM track summary and (User)Quiz
 */
export interface ScormTrackSummaryPreload {
  /**
   * Copied from ScormTrackSummary
   */
  id: (common_db.DbKey<ScormTrackSummary>|null);
  importId: (common_db.DbKey<ImportEvent>|null);
  trackid: (string|null);
  userid: (string|null);
  courseid: (string|null);
  openedat: (common.Instant|null);
  /**
   * Flattened out from  '[SCO name].cmi.core' object (SCORM 1.2) or '[SCO name].cmi' object (SCORM 2004)
   */
  completionStatus: (ScormCompletionStatus|null);
  total_time: (string|null);
  scoreRaw: (ScormScore|null);
  totaltime: (string|null);
  completedat: (common.Instant|null);
  benchmark: number;
}

export function makeScormTrackSummaryPreload(
  input: {
    id: (common_db.DbKey<ScormTrackSummary>|null),
    importId: (common_db.DbKey<ImportEvent>|null),
    trackid: (string|null),
    userid: (string|null),
    courseid: (string|null),
    openedat: (common.Instant|null),
    completionStatus: (ScormCompletionStatus|null),
    total_time: (string|null),
    scoreRaw: (ScormScore|null),
    totaltime: (string|null),
    completedat: (common.Instant|null),
    benchmark: number,
  }
): ScormTrackSummaryPreload {
  return {
    id: input.id,
    importId: input.importId,
    trackid: input.trackid,
    userid: input.userid,
    courseid: input.courseid,
    openedat: input.openedat,
    completionStatus: input.completionStatus,
    total_time: input.total_time,
    scoreRaw: input.scoreRaw,
    totaltime: input.totaltime,
    completedat: input.completedat,
    benchmark: input.benchmark,
  };
}

const ScormTrackSummaryPreload_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.scodlemigration","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ScormTrackSummary"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"importId","default":{"kind":"nothing"},"name":"importId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ImportEvent"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"trackid","default":{"kind":"nothing"},"name":"trackid","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"userid","default":{"kind":"nothing"},"name":"userid","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"courseid","default":{"kind":"nothing"},"name":"courseid","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"openedat","default":{"kind":"nothing"},"name":"openedat","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"completionStatus","default":{"kind":"nothing"},"name":"completionStatus","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ScormCompletionStatus"}},"parameters":[]}]}},{"annotations":[],"serializedName":"total_time","default":{"kind":"nothing"},"name":"total_time","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"scoreRaw","default":{"kind":"nothing"},"name":"scoreRaw","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ScormScore"}},"parameters":[]}]}},{"annotations":[],"serializedName":"totaltime","default":{"kind":"nothing"},"name":"totaltime","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"completedat","default":{"kind":"nothing"},"name":"completedat","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"benchmark","default":{"kind":"nothing"},"name":"benchmark","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"ScormTrackSummaryPreload","version":{"kind":"nothing"}}};

export const snScormTrackSummaryPreload: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.scodlemigration", name:"ScormTrackSummaryPreload"};

export function texprScormTrackSummaryPreload(): ADL.ATypeExpr<ScormTrackSummaryPreload> {
  return {value : {typeRef : {kind: "reference", value : snScormTrackSummaryPreload}, parameters : []}};
}

/**
 * Fetching details of just one track interaction.
 * Maps onto UserQuiz, UserQuizQuestionSubmission, but no real UserQuizQuestionEvent stuff here
 */
export interface ScormTrackInteraction {
  importId: common_db.DbKey<ImportEvent>;
  trackid: string;
  userid: string;
  courseid: string;
  openedat: common.Instant;
  completedat: (common.Instant|null);
  totaltime: (string|null);
  /**
   * Logged here for reference
   */
  SCOName: string;
  /**
   * Logged here for reference
   */
  SCORMVersion: string;
  /**
   * Flattened out from  '[SCO name].cmi.core' object (SCORM 1.2) or '[SCO name].cmi' object (SCORM 2004)
   */
  completionStatus: ScormCompletionStatus;
  total_time: (string|null);
  exit: (string|null);
  /**
   * Flattened out from '[SCO name].cmi.core.score' (SCORM 1.2) or '[SCO name].cmi.score' (SCORM 2004)
   */
  scoreRaw: (ScormScore|null);
  scoreMin: (ScormScore|null);
  scoreMax: (ScormScore|null);
  /**
   * Order of the interaction (0-)
   */
  number: number;
  /**
   * Maps to Question.content
   */
  interactionId: (string|null);
  /**
   * Maps to Competency
   */
  objectiveIds: (string|null);
  /**
   * Maps to UserQuizQuestionSubmission.score
   */
  result: (ScormScore|null);
  /**
   * Content of response (maps to value of UserQuizQuestionSubmission.answerResponse)
   */
  learnerResponse: (string|null);
  /**
   * "type" is a reserved word in ADL
   */
  answerType: string;
  time: (string|null);
  content: (string|null);
}

export function makeScormTrackInteraction(
  input: {
    importId: common_db.DbKey<ImportEvent>,
    trackid: string,
    userid: string,
    courseid: string,
    openedat: common.Instant,
    completedat: (common.Instant|null),
    totaltime: (string|null),
    SCOName: string,
    SCORMVersion: string,
    completionStatus: ScormCompletionStatus,
    total_time: (string|null),
    exit: (string|null),
    scoreRaw: (ScormScore|null),
    scoreMin: (ScormScore|null),
    scoreMax: (ScormScore|null),
    number: number,
    interactionId: (string|null),
    objectiveIds: (string|null),
    result: (ScormScore|null),
    learnerResponse: (string|null),
    answerType: string,
    time: (string|null),
    content: (string|null),
  }
): ScormTrackInteraction {
  return {
    importId: input.importId,
    trackid: input.trackid,
    userid: input.userid,
    courseid: input.courseid,
    openedat: input.openedat,
    completedat: input.completedat,
    totaltime: input.totaltime,
    SCOName: input.SCOName,
    SCORMVersion: input.SCORMVersion,
    completionStatus: input.completionStatus,
    total_time: input.total_time,
    exit: input.exit,
    scoreRaw: input.scoreRaw,
    scoreMin: input.scoreMin,
    scoreMax: input.scoreMax,
    number: input.number,
    interactionId: input.interactionId,
    objectiveIds: input.objectiveIds,
    result: input.result,
    learnerResponse: input.learnerResponse,
    answerType: input.answerType,
    time: input.time,
    content: input.content,
  };
}

const ScormTrackInteraction_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.scodlemigration","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"importId","default":{"kind":"nothing"},"name":"importId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ImportEvent"}},"parameters":[]}]}},{"annotations":[],"serializedName":"trackid","default":{"kind":"nothing"},"name":"trackid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"userid","default":{"kind":"nothing"},"name":"userid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"courseid","default":{"kind":"nothing"},"name":"courseid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"openedat","default":{"kind":"nothing"},"name":"openedat","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"completedat","default":{"kind":"nothing"},"name":"completedat","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"totaltime","default":{"kind":"nothing"},"name":"totaltime","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"SCOName","default":{"kind":"nothing"},"name":"SCOName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"SCORMVersion","default":{"kind":"nothing"},"name":"SCORMVersion","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"completionStatus","default":{"kind":"nothing"},"name":"completionStatus","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ScormCompletionStatus"}},"parameters":[]}},{"annotations":[],"serializedName":"total_time","default":{"kind":"nothing"},"name":"total_time","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"exit","default":{"kind":"nothing"},"name":"exit","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"scoreRaw","default":{"kind":"nothing"},"name":"scoreRaw","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ScormScore"}},"parameters":[]}]}},{"annotations":[],"serializedName":"scoreMin","default":{"kind":"nothing"},"name":"scoreMin","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ScormScore"}},"parameters":[]}]}},{"annotations":[],"serializedName":"scoreMax","default":{"kind":"nothing"},"name":"scoreMax","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ScormScore"}},"parameters":[]}]}},{"annotations":[],"serializedName":"number","default":{"kind":"nothing"},"name":"number","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}},{"annotations":[],"serializedName":"interactionId","default":{"kind":"nothing"},"name":"interactionId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"objectiveIds","default":{"kind":"nothing"},"name":"objectiveIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"result","default":{"kind":"nothing"},"name":"result","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ScormScore"}},"parameters":[]}]}},{"annotations":[],"serializedName":"learnerResponse","default":{"kind":"nothing"},"name":"learnerResponse","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"answerType","default":{"kind":"nothing"},"name":"answerType","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"time","default":{"kind":"nothing"},"name":"time","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"content","default":{"kind":"nothing"},"name":"content","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"ScormTrackInteraction","version":{"kind":"nothing"}}};

export const snScormTrackInteraction: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.scodlemigration", name:"ScormTrackInteraction"};

export function texprScormTrackInteraction(): ADL.ATypeExpr<ScormTrackInteraction> {
  return {value : {typeRef : {kind: "reference", value : snScormTrackInteraction}, parameters : []}};
}

export interface ScormTrackInteractionPreload {
  /**
   * Copied from ScormTrackInteraction
   */
  id: common_db.DbKey<ScormTrackInteraction>;
  importId: common_db.DbKey<ImportEvent>;
  trackid: string;
  userid: string;
  courseid: string;
  totaltime: (string|null);
  completionStatus: ScormCompletionStatus;
  total_time: (string|null);
  exit: string;
  scoreRaw: ScormScore;
  number: number;
  interactionId: string;
  /**
   * Maps to Competency
   */
  objectiveIds: string;
  result: ScormScore;
  learnerResponse: string;
  answerType: string;
  /**
   * Updated following linking to other db objects
   */
  competency: (string|null);
  /**
   * Updated following linking to other db objects
   */
  skillId: (common_db.DbKey<totalinteraction_futurefit_db.Skill>|null);
  /**
   * Updated following linking to other db objects
   */
  questionContent: (string|null);
  /**
   * Updated following linking to other db objects
   */
  questionId: (common_db.DbKey<totalinteraction_futurefit_db.Question>|null);
  /**
   * Updated following linking to other db objects
   */
  quizQuestionId: (common_db.DbKey<totalinteraction_futurefit_db.QuizQuestion>|null);
  time: (string|null);
  /**
   * Keep track of what's been propagated to SS tables
   */
  exported: boolean;
}

export function makeScormTrackInteractionPreload(
  input: {
    id: common_db.DbKey<ScormTrackInteraction>,
    importId: common_db.DbKey<ImportEvent>,
    trackid: string,
    userid: string,
    courseid: string,
    totaltime: (string|null),
    completionStatus: ScormCompletionStatus,
    total_time: (string|null),
    exit: string,
    scoreRaw: ScormScore,
    number: number,
    interactionId: string,
    objectiveIds: string,
    result: ScormScore,
    learnerResponse: string,
    answerType: string,
    competency: (string|null),
    skillId: (common_db.DbKey<totalinteraction_futurefit_db.Skill>|null),
    questionContent: (string|null),
    questionId: (common_db.DbKey<totalinteraction_futurefit_db.Question>|null),
    quizQuestionId: (common_db.DbKey<totalinteraction_futurefit_db.QuizQuestion>|null),
    time: (string|null),
    exported?: boolean,
  }
): ScormTrackInteractionPreload {
  return {
    id: input.id,
    importId: input.importId,
    trackid: input.trackid,
    userid: input.userid,
    courseid: input.courseid,
    totaltime: input.totaltime,
    completionStatus: input.completionStatus,
    total_time: input.total_time,
    exit: input.exit,
    scoreRaw: input.scoreRaw,
    number: input.number,
    interactionId: input.interactionId,
    objectiveIds: input.objectiveIds,
    result: input.result,
    learnerResponse: input.learnerResponse,
    answerType: input.answerType,
    competency: input.competency,
    skillId: input.skillId,
    questionContent: input.questionContent,
    questionId: input.questionId,
    quizQuestionId: input.quizQuestionId,
    time: input.time,
    exported: input.exported === undefined ? false : input.exported,
  };
}

const ScormTrackInteractionPreload_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.scodlemigration","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ScormTrackInteraction"}},"parameters":[]}]}},{"annotations":[],"serializedName":"importId","default":{"kind":"nothing"},"name":"importId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ImportEvent"}},"parameters":[]}]}},{"annotations":[],"serializedName":"trackid","default":{"kind":"nothing"},"name":"trackid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"userid","default":{"kind":"nothing"},"name":"userid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"courseid","default":{"kind":"nothing"},"name":"courseid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"totaltime","default":{"kind":"nothing"},"name":"totaltime","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"completionStatus","default":{"kind":"nothing"},"name":"completionStatus","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ScormCompletionStatus"}},"parameters":[]}},{"annotations":[],"serializedName":"total_time","default":{"kind":"nothing"},"name":"total_time","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"exit","default":{"kind":"nothing"},"name":"exit","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"scoreRaw","default":{"kind":"nothing"},"name":"scoreRaw","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ScormScore"}},"parameters":[]}},{"annotations":[],"serializedName":"number","default":{"kind":"nothing"},"name":"number","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}},{"annotations":[],"serializedName":"interactionId","default":{"kind":"nothing"},"name":"interactionId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"objectiveIds","default":{"kind":"nothing"},"name":"objectiveIds","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"result","default":{"kind":"nothing"},"name":"result","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.scodlemigration","name":"ScormScore"}},"parameters":[]}},{"annotations":[],"serializedName":"learnerResponse","default":{"kind":"nothing"},"name":"learnerResponse","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"answerType","default":{"kind":"nothing"},"name":"answerType","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"competency","default":{"kind":"nothing"},"name":"competency","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"skillId","default":{"kind":"nothing"},"name":"skillId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Skill"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"questionContent","default":{"kind":"nothing"},"name":"questionContent","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"questionId","default":{"kind":"nothing"},"name":"questionId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"Question"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"quizQuestionId","default":{"kind":"nothing"},"name":"quizQuestionId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db","name":"QuizQuestion"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"time","default":{"kind":"nothing"},"name":"time","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"exported","default":{"kind":"just","value":false},"name":"exported","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"ScormTrackInteractionPreload","version":{"kind":"nothing"}}};

export const snScormTrackInteractionPreload: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.scodlemigration", name:"ScormTrackInteractionPreload"};

export function texprScormTrackInteractionPreload(): ADL.ATypeExpr<ScormTrackInteractionPreload> {
  return {value : {typeRef : {kind: "reference", value : snScormTrackInteractionPreload}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "totalinteraction.futurefit.db.scodlemigration.ScodleControl" : ScodleControl_AST,
  "totalinteraction.futurefit.db.scodlemigration.ImportEvent" : ImportEvent_AST,
  "totalinteraction.futurefit.db.scodlemigration.ScormCourse" : ScormCourse_AST,
  "totalinteraction.futurefit.db.scodlemigration.ScormCoursePreload" : ScormCoursePreload_AST,
  "totalinteraction.futurefit.db.scodlemigration.ScormUser" : ScormUser_AST,
  "totalinteraction.futurefit.db.scodlemigration.ScormUserPreload" : ScormUserPreload_AST,
  "totalinteraction.futurefit.db.scodlemigration.ScormEnrolment" : ScormEnrolment_AST,
  "totalinteraction.futurefit.db.scodlemigration.ScormScore" : ScormScore_AST,
  "totalinteraction.futurefit.db.scodlemigration.ScormCompletionStatus" : ScormCompletionStatus_AST,
  "totalinteraction.futurefit.db.scodlemigration.ScormTrackSummary" : ScormTrackSummary_AST,
  "totalinteraction.futurefit.db.scodlemigration.ScormTrackSummaryPreload" : ScormTrackSummaryPreload_AST,
  "totalinteraction.futurefit.db.scodlemigration.ScormTrackInteraction" : ScormTrackInteraction_AST,
  "totalinteraction.futurefit.db.scodlemigration.ScormTrackInteractionPreload" : ScormTrackInteractionPreload_AST
};



// WEBPACK FOOTER //
// ./src/adl-gen/totalinteraction/futurefit/db/scodlemigration.ts